module.exports = __webpack_public_path__ + "img/6_ralph_n.c61e481d.png";